import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ClockIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import type { Location } from '../data/locations';
import { SERVICES } from '../data/locations';
type LocationCardProps = {
  location: Location;
  index?: number;
};
export function LocationCard({
  location,
  index = 0
}: LocationCardProps) {
  return <motion.article initial={{
    opacity: 0,
    y: 16
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.35,
    delay: Math.min(index, 5) * 0.05,
    ease: 'easeOut'
  }} className="group flex flex-col overflow-hidden rounded-2xl border border-white/[0.07] bg-ink-850/70 transition-all duration-300 hover:border-lotus-500/50 hover:bg-ink-800/70" data-id="element-49" data-mp="2txzuqognio2c">
      <Link to={`/locations/${location.slug}`} className="relative block overflow-hidden" data-id="element-50" data-mp="19hmp2p3270ib">
        <img src={location.image} alt={`${location.name} treatment room`} className="h-52 w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" loading="lazy" data-id="element-51" data-mp="1egg62rhk19n8" />
        <span className="absolute inset-0 bg-gradient-to-t from-ink-850 via-ink-950/20 to-transparent" data-id="element-52" data-mp="3m89lixs8i4vf" />
        <span className="absolute inset-0 opacity-40 mix-blend-soft-light transition-opacity duration-500 group-hover:opacity-70" style={{
        backgroundImage: 'linear-gradient(120deg, rgba(232,54,127,0.55) 0%, rgba(168,85,247,0.45) 100%)'
      }} data-id="element-53" data-mp="3hazp2y6fgsy3" />
        <span className="absolute bottom-4 left-5 text-[11px] font-medium uppercase tracking-[0.28em] text-lotus-300" data-id="element-54" data-mp="8uxuwp85g84s">
          {location.suburb}
        </span>
      </Link>

      <div className="flex flex-1 flex-col p-6" data-id="element-55" data-mp="3vzvu0md6tpuh">
        <h3 className="font-display text-2xl font-light tracking-wide text-white" data-id="element-56" data-mp="3w16xsm6muxll">
          {location.name}
        </h3>

        <ul className="mt-4 space-y-2.5 text-sm font-light text-neutral-400" data-id="element-57" data-mp="2kk771uzxoqto">
          <li className="flex gap-2.5" data-id="element-58" data-mp="2kmbl35rjr67o">
            <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-lotus-400" aria-hidden="true" data-id="element-59" data-mp="2m0ur0gorif60" />
            {location.address}
          </li>
          <li className="flex gap-2.5" data-id="element-60" data-mp="2qzfsejfr34w1">
            <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-lotus-400" aria-hidden="true" data-id="element-61" data-mp="2c36txk3oovko" />
            <a href={`tel:${location.phone.replace(/\s/g, '')}`} className="hover:text-lotus-300" data-id="element-62" data-mp="2h1rl6u0yk4wz">
              {location.phone}
            </a>
          </li>
          <li className="flex gap-2.5" data-id="element-63" data-mp="239brwkxuzl99">
            <ClockIcon className="mt-0.5 h-4 w-4 shrink-0 text-orchid-400" aria-hidden="true" data-id="element-64" data-mp="2813944v4kemq" />
            {location.hours}
          </li>
        </ul>

        <ul className="mt-5 flex flex-wrap gap-2" data-id="element-65" data-mp="1te07blzrrjtl">
          {SERVICES.map(service => <li key={service.duration} className="rounded-full border border-orchid-400/30 bg-orchid-500/10 px-3 py-1 text-[11px] font-medium tracking-wide text-orchid-300" data-id="element-66" data-mp="1yc1r6950rn64">
              {service.duration} · {service.price}
            </li>)}
        </ul>

        <Link to={`/locations/${location.slug}`} className="mt-auto inline-flex items-center gap-2 pt-6 text-[11px] font-semibold uppercase tracking-[0.24em] text-lotus-400 transition-colors hover:text-lotus-300" data-id="element-67" data-mp="15pbv341jcoq2">
          View Location
          <ArrowRightIcon className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-68" data-mp="19plzic9oj72t" />
        </Link>
      </div>
    </motion.article>;
}